module.exports = __webpack_public_path__ + "img/图2.b94bed74.png";